import React from 'react'
import { Form, Input, Select } from "antd";
import { Button } from "evergreen-ui";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import FireFetch from "../../../Firebase/FireFetch";
import { getDatabase, ref } from "firebase/database";
import { generatePath, useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthContext/AuthContext";
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

const moment = require("moment");
var db = getDatabase(Firebase);
const EnterQuiz = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateQuiz = canAccessModule("QUIZZES", "create");
	const [categoryArray] = useListVals(ref(db, "talmidsdb/categories"));
	const [lessonArray] = useListVals(ref(db, "talmidsdb/lessons"));
	const [languageArray] = useListVals(ref(db, "talmidsdb/languages"));
	const navigate = useNavigate();

	const proceedToDetails = (id, object) => {
		navigate(generatePath("/quizzes/:id", { id }), { state: { quiz: object } });
	};

	const addQuiz = (values) => {
		if (!canCreateQuiz) {
			return;
		}

		var objectID = Array(20).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz")
			.map(function (x) {
				return x[Math.floor(Math.random() * x.length)]
			}).join('');

		var timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");
		var object = {
			"title": values.title,
			"lessonID": values.lesson,
			"categoryID": values.category,
			"languageID": values.language,
			"quizID": objectID,
			"dateCreated": timeStamp
		}

		const output = FireFetch.SaveTODB("quizzes", objectID, object);
		output.then((result) => {
			if (result === "success") {
				FireFetch.addLog("quizzes", objectID, "Edit");
				proceedToDetails(objectID, object);
				//props.setState(object);
				//props.next();
			} else {
				//setMessage("Unable to add quiz, an error occurred :: " + result);
				//setColor("danger");
				//setShowAlert(true);
			}
		});
	}

	return (
		<>
			<Form
				onFinish={addQuiz}
				className="p-3 font-Nunito"
				id='my-form'
			>
				<Form.Item label="Quiz Title" name="title"
					rules={[{ required: true, message: 'Please input title!' }]}>
					<Input placeholder="enter quiz title" id="title" />
				</Form.Item>
				<Form.Item label="Lesson" name="lesson"
					rules={[{ required: true, message: 'Please select lesson!' }]}>
					<Select placeholder="Select quiz lesson"
						showSearch
						optionFilterProp="children"
						filterOption={filterSelectOption}
						filterSort={sortSelectOptions}
					>
						{lessonArray?.map((item, index) => (
							<Select.Option key={index} value={item.id}>{item.lessonName}</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item label="Category" name="category"
					rules={[{ required: true, message: 'Please select category!' }]}>
					<Select placeholder="Select quiz category">
						{categoryArray?.map((item, index) => (
							<Select.Option key={index} value={item.id}>{item.name}</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item label="Language" name="language"
					rules={[{ required: true, message: 'Please input language!' }]}>
					<Select placeholder="Select quiz language">
						{languageArray?.map((item, index) => (
							<Select.Option key={index} value={item.id}>{item.languageName}</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Button id="btnSubmit" appearance="primary" htmlType="submit" disabled={!canCreateQuiz}>
					Next
				</Button>
			</Form>
		</>
	)
}

export default EnterQuiz;
